"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _currencyFormatter = _interopRequireDefault(require("@sprinx/formatting/currencyFormatter"));

var _ProductPriceElementBase = _interopRequireDefault(require("@sprinx/react-com/ProductPriceElementBase"));

var useStyles = (0, _styles.makeStyles)(function () {
  return (
    /* theme */
    {
      root: {},
      price: {},
      label: {},
      labelEnd: {},
      labelStart: {}
    }
  );
}, {
  name: 'SxComProductPriceElementPriceCvo'
});

function ProductPriceElementPriceCvo(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      color = _ref.color,
      _ref$component = _ref.component,
      Component = _ref$component === void 0 ? _ProductPriceElementBase.default : _ref$component,
      currency = _ref.currency,
      decoration = _ref.decoration,
      labelEnd = _ref.labelEnd,
      labelStart = _ref.labelStart,
      size = _ref.size,
      value = _ref.value,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "color", "component", "currency", "decoration", "labelEnd", "labelStart", "size", "value"]);
  var classes = useStyles({
    classes: pClasses
  });

  var formattedPrice = _react.default.useMemo(function () {
    if (value !== undefined) {
      var formattedValue = (0, _currencyFormatter.default)(value, currency);

      if (currency === 'CZK' && formattedValue.includes(',00')) {
        var formattedValueCZ = formattedValue.replace(',00', '');
        return formattedValueCZ;
      }

      return formattedValue;
    }

    return undefined;
  }, [currency, value]);

  return formattedPrice ? /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
    classes: classes,
    className: (0, _clsx.default)(classes.root, className),
    currency: currency,
    formattedValue: formattedPrice,
    decoration: decoration,
    color: color,
    size: size,
    labelStart: labelStart,
    labelEnd: labelEnd
  }, rest), formattedPrice) : null;
}

process.env.NODE_ENV !== "production" ? ProductPriceElementPriceCvo.propTypes = {
  classes: _propTypes.default.shape({
    label: _propTypes.default.string,
    price: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  color: _propTypes.default.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),
  component: _propTypes.default.elementType,
  currency: _propTypes.default.string.isRequired,
  decoration: _propTypes.default.oneOf(['none', 'strike']),
  labelEnd: _propTypes.default.node,
  labelStart: _propTypes.default.node,
  size: _propTypes.default.oneOf(['large', 'medium', 'small']),
  value: _propTypes.default.number
} : void 0;
ProductPriceElementPriceCvo.defaultProps = {
  classes: undefined,
  className: undefined,
  color: 'initial',
  component: undefined,
  decoration: 'none',
  labelEnd: undefined,
  labelStart: undefined,
  size: 'medium',
  value: undefined
};
var _default = ProductPriceElementPriceCvo;
exports.default = _default;